'use strict';

import MemoPlaceholder from '../components/MemoPlaceholder';

new MemoPlaceholder();
new MemoPlaceholder(document.documentElement, {
    namespace: 'input-round',
    selector: '.input-round',
});
